import { CheckboxInputGroup } from '../input-group/checkbox-input-group';
import type { ParentItem } from '~/types/master-data';
import type { SearchConditions } from '~/types/search-conditions';

interface LicenseFormProps {
  mappedLicenses: ParentItem[];
  searchConditions: SearchConditions;
  updateParentChecked: (
    item: ParentItem,
    type: keyof SearchConditions,
    checked: boolean,
  ) => void;
  updateChecked: (
    type: keyof SearchConditions,
    name: string,
    checked: boolean,
  ) => void;
}

export function LicenseForm(props: LicenseFormProps) {
  return (
    <div className="px-4 pb-4 border-b">
      <div className="p-side-search-form__section__title -license hidden md:block">
        資格
      </div>
      <table className="mt-6 md:mt-0 c-table-form -th-long js-parent-child-checkbox">
        <tbody>
          {props.mappedLicenses.map((license) => (
            <tr key={`license-${license.id}`}>
              <th className="parent-cb">
                <CheckboxInputGroup
                  id={`license-${license.id}`}
                  name="jobs_search[license_names][]"
                  value={license.name}
                  label={license.name}
                  checked={license.children?.every((child) =>
                    props.searchConditions.licenseNames.includes(child.name),
                  )}
                  updateChecked={(checked: boolean) =>
                    props.updateParentChecked(license, 'licenseNames', checked)
                  }
                />
              </th>
              <td>
                <div className="flex flex-wrap gap-4">
                  {license.children?.map((child) => (
                    <CheckboxInputGroup
                      key={`license-${child.id}`}
                      id={`license-${child.id}`}
                      name="jobs_search[license_names][]"
                      value={child.name}
                      label={child.name}
                      checked={props.searchConditions.licenseNames.includes(
                        child.name,
                      )}
                      updateChecked={(checked: boolean) =>
                        props.updateChecked('licenseNames', child.name, checked)
                      }
                    />
                  ))}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
